import type { Ref } from 'vue'
import { reactive, readonly, toRefs, watch } from 'vue'
import type { Asset } from '@/entities/asset'

export const useCompanyAssets = (companyId: Ref<number | undefined>) => {
  const state = reactive({
    loading: false,
    error: null as Error | null,
    assets: [] as Asset[],
  })

  const _getAssets = async (companyId: number) => {
    try {
      state.error = null
      state.loading = true
      state.assets = (await $fetch<any>(`v2/companies/${companyId}/assets`, { ...useFetchSharedOptions() })).results
    } catch (e) {
      if (e instanceof Error) {
        state.error = e
      }
    } finally {
      state.loading = false
    }
  }

  watch(
    companyId,
    companyId => {
      if (companyId) {
        _getAssets(companyId)
      } else {
        state.assets = []
      }
    },
    { immediate: true }
  )

  return toRefs(readonly(state))
}
